import { FunctionComponent, useCallback, useState } from 'react'
import Icon from '@/components/HeroIcons'
import { Button, Link } from '@conexasaude/hero'
import { useParams, useHistory } from 'react-router'
import { useChatLayerStore } from '@/components/ChatLayer'
import { RenderIf } from '@/components/RenderIf'

interface IStartFormProps {
  onClickLogin(): void
}

const StartForm: FunctionComponent<IStartFormProps> = ({ onClickLogin }) => {
  const params = useParams<{ clinic?: string }>()
  const { push } = useHistory()
  const openChatLayer = useChatLayerStore(state => state.openChatLayer)
  const [imageError, setImageError] = useState(false)

  const goToSignUp = useCallback(() => {
    push('/cadastro/inicio')
  }, [push])

  return (
    <div className="start-form">
      <RenderIf condition={!!params.clinic && !imageError}>
        <img
          src={`${process.env.REACT_APP_LINK_LOGO_AWS}${params.clinic}.png`}
          alt="logo"
          className={'logo-whitelabel mb-3'}
          onError={event => {
            event.currentTarget.onerror = null
            setImageError(true)
            event.currentTarget.style.height = 'auto'
          }}
        />
      </RenderIf>
      <RenderIf condition={!params.clinic || imageError}>
        <Icon
          name="conexa-logo"
          width={'270px'}
          height={'60px'}
          className="mb-3"
        />
      </RenderIf>

      <h1>Conecte-se à sua saúde</h1>
      <h3 className="mb-5">
        Crie uma conta para agendar ou realizar consultas
      </h3>
      <Button
        className="button-login"
        onClick={goToSignUp}
        fullWidth
        size="sm"
        variant="flat"
      >
        Criar conta
      </Button>

      <Button
        className="button-login"
        onClick={onClickLogin}
        fullWidth
        size="sm"
        variant="outlined"
      >
        Entrar
      </Button>

      <Link className="link-support-start" onClick={openChatLayer}>
        Precisa de ajuda?
      </Link>
    </div>
  )
}

export default StartForm
